const SuccessPage = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>Payment Successful!</h1>
            <p>Your payment was successfully authorized.</p>
        </div>
    );
};

export default SuccessPage;
